import type { JobRun, JobRunLogResult } from "./types";
import { useJobRunQueryMessages } from "./useJobRunQueryMessages";
import { useJobRunS3Log } from "./useJobRunS3Log";

export const useJobRunLogs = (jobRun: JobRun): JobRunLogResult => {
  const s3PathQuery = useJobRunS3Log(jobRun, { enabled: !!jobRun.s3LogPath });
  const jobRunQuery = useJobRunQueryMessages(jobRun.jobRunId, {
    enabled: !jobRun.s3LogPath && !!jobRun.jobRunId,
  });

  if (jobRun.s3LogPath) {
    return s3PathQuery;
  }
  if (jobRun.jobRunId) {
    return jobRunQuery;
  }

  return { loading: false, error: null, data: [], logSource: "" };
};
